import { render, staticRenderFns } from "./FPFPhone.vue?vue&type=template&id=66006cb6&scoped=true"
import script from "./FPFPhone.vue?vue&type=script&lang=js"
export * from "./FPFPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66006cb6",
  null
  
)

export default component.exports